/** A field in a block's settings schema (mirrors the PHP settingsSchema()). */

/** Manifest entry for a block, as returned by GET /pagebuilder/manifest. */

/** A block's client component receives its settings + server-resolved data. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Client-side block registry. Block components register here under the same
 * `type` key their PHP counterpart uses; the LayoutRenderer looks them up.
 * Exposed on `app.pageBuilder` so third-party extensions can register blocks.
 */
class PageBuilderRegistry {
  components = {};
  registerBlock(type, component) {
    this.components[type] = component;
  }

  /**
   * Absorb definitions pushed onto `window.PageBuilderBlockQueue`.
   *
   * 🚨 The order-proof registration path. `app.pageBuilder` does not exist
   * until this extension's own initializer has run, and which of two
   * extensions initialises first is not something either of them decides — so
   * a third-party block registered directly is a coin toss that lands as a
   * block missing from the page with nothing in the console. Queue at any
   * time; we drain on every lookup.
   *
   * An already-registered type wins, so a site that overrides a block keeps
   * its override.
   */
  drainQueue() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queue = window.PageBuilderBlockQueue;
    if (Array.isArray(queue) && queue.length) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      queue.splice(0).forEach(entry => {
        if (entry && entry.type && entry.component && !this.components[entry.type]) {
          this.registerBlock(entry.type, entry.component);
        }
      });
    }
  }
  getBlock(type) {
    this.drainQueue();
    return this.components[type];
  }
  has(type) {
    this.drainQueue();
    return !!this.components[type];
  }
}
export const registry = new PageBuilderRegistry();

/** Attrs a field input component receives in a record form. */

/** Attrs a field display component receives on a record page. */

// eslint-disable-next-line @typescript-eslint/no-explicit-any

/**
 * Registry of field-type UI: an input component (record forms) and a display
 * component (record pages) per field type, keyed by the type's key. Exposed on
 * app.pageBuilder.fields so extensions can register custom field UIs.
 */
class FieldRegistry {
  fields = {};
  register(type, input, display) {
    this.fields[type] = {
      input,
      display
    };
  }
  input(type) {
    return this.fields[type]?.input;
  }
  display(type) {
    return this.fields[type]?.display;
  }
}
export const fieldRegistry = new FieldRegistry();